import script from "./CallToActionSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallToActionSection.vue?vue&type=script&lang=ts&setup=true"

import "./CallToActionSection.vue?vue&type=style&index=0&id=782ed94e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-782ed94e"]])

export default __exports__